import React, {useRef, useState, useEffect} from 'react'
import { Button, Modal } from 'antd';
import {Container,ModalButton} from './styles';
import Loader from '../Loader';
import { auth } from '../../config/fire';
export const ScreenReq = (props) => {

  
    return (

      <Modal visible={props.visiblity}
      onCancel={props.onCancel}
      footer={null}
      width={450}
      centered
      >
      
     {props.children}
      </Modal>
    )
}
